enum Key {
    Alt = "alt",
    Command = "command",
    Control = "control",
    Option = "option",
}

export { Key };
